<div class="container-fluid footer">
  <div class="footer-wrapper">
    <div class="row">
      <div class="col-lg col-md-4  justify-content-center">
        <div class="footer-group-container">
          <div class="footer-group-item-title float-left" onclick="toggleFooter(this, 'footerNajpopularniejsze')">
            Najpopularniejsze
            <span class="float-end footer-group-item-caret"><i class="fa fa-angle-down"></i></span>
          </div>
          <div class="footer-group-items-container" id="footerNajpopularniejsze">
            <a class="footer-group-item nowrap" href="https://bricomarche.pl/porady" target="_blank">Porady</a>
            <a class="footer-group-item nowrap" href="https://bricomarche.pl/farby-i-lakiery" target="_blank">Farby</a>
            <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/plytki-i-gresy"
              target="_blank">Płytki</a>
            <a class="footer-group-item nowrap"
              href="https://bricomarche.pl/narzedzia-i-akcesoria/elektronarzedzia-akcesoria"
              target="_blank">Elektronarzędzia</a>
            <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/panele-podlogowe"
              target="_blank">Panele</a>
            <a class="footer-group-item nowrap" href="https://bricomarche.pl/budowanie" target="_blank">Materiały
              budowlane</a>
            <a class="footer-group-item nowrap" href="https://bricomarche.pl/elektryka" target="_blank">Elektryka</a>
            <a class="footer-group-item nowrap" href="https://bricomarche.pl/ogrod" target="_blank">Ogród</a>
            <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/twoja-idealna-lazienka"
              target="_blank">Projekt łazienki</a>
          </div>
          <hr class="footer-hr" />
        </div>
      </div>
      <div class="col-lg col-md-4  justify-content-center">
        <div style="display:block !important">
          <div class="footer-group-container">
            <div class="footer-group-item-title" onclick="toggleFooter(this, 'footerSklepInternetowy')">
              Sklep internetowy
              <span class="float-end footer-group-item-caret"><i class="fa fa-angle-down"></i></span>
            </div>
            <div class="footer-group-items-container" id="footerSklepInternetowy">
              <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/metody-platnosci"
                target="_blank">Metody płatności</a>
              <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/zwroty" target="_blank">Zwroty sklep
                internetowy</a>
              <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/aplikacja" target="_blank">Program
                lojalnościowy</a>
              <a class="footer-group-item nowrap"
                href="https://play.google.com/store/apps/details?id=pl.bricomarche.app&hl=pl" target="_blank">Aplikacja
                Mobilna</a>
              <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/strefa-marek-bricomarche"
                target="_blank">Strefa Marek</a>
              <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/zglos_blad" target="_blank">Zgłoś
                błąd</a>
              <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/faq" target="_blank">FAQ</a>
            </div>
            <hr class="footer-hr" />
          </div>
          <div class="footer-group-container">
            <div class="footer-group-item-title" onclick="toggleFooter(this, 'footerRegulaminy')">
              Regulaminy
              <span class="float-end footer-group-item-caret"><i class="fa fa-angle-down"></i></span>
            </div>
            <div class="footer-group-items-container" id="footerRegulaminy">
              <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/regulamin_serwisu_internetowego"
                target="_blank">Regulaminy</a>
              <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/polityka_prywatnosci"
                target="_blank">Polityka
                prywatności</a>
            </div>
            <hr class="footer-hr" />
          </div>
        </div>

      </div>

      <div class="col-lg col-md-4  justify-content-center">
        <div class="block">
          <div class="footer-group-container">
            <div class="footer-group-item-title" onclick="toggleFooter(this, 'footerPromocje')">
              Promocje
              <span class="float-end footer-group-item-caret"><i class="fa fa-angle-down"></i></span>
            </div>
            <div class="footer-group-items-container" id="footerPromocje">
              <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/gazetka" target="_blank">Gazetka</a>
              <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/promocje" target="_blank">Oferta
                specjalna</a>
            </div>
            <hr class="footer-hr" />
          </div>
          <div class="footer-group-container">
            <div class="footer-group-item-title" onclick="toggleFooter(this, 'footerNaszeSklepy')">
              Nasze sklepy
              <span class="float-end footer-group-item-caret"><i class="fa fa-angle-down"></i></span>
            </div>
            <div class="footer-group-items-container" id="footerNaszeSklepy">
              <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/sklepy" target="_blank">Sklepy</a>
              <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/uslugi" target="_blank">Usługi</a>
              <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/dostawa" target="_blank">Dostawa</a>
              <a class="footer-group-item nowrap" href="https://kartypodarunkowe.bricomarche.pl/" target="_blank">Karty
                podarunkowe</a>
              <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/raty-i-karta-kredytowa"
                target="_blank">Raty i karta kredytowa</a>
              <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/zwrot-zuzytego-sprzetu"
                target="_blank">Zwrot zużytego sprzętu</a>
            </div>
            <hr class="footer-hr" />
          </div>
        </div>

      </div>

      <div class="col-lg col-md-4  justify-content-center">
        <div class="footer-group-container">
          <div class="footer-group-item-title" onclick="toggleFooter(this, 'footerONas')">
            O nas
            <span class="float-end footer-group-item-caret"><i class="fa fa-angle-down"></i></span>
          </div>
          <div class="footer-group-items-container" id="footerONas">
            <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/kim-jestesmy" target="_blank">Kim
              jesteśmy</a>
            <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/aktualnosci"
              target="_blank">Aktualności</a>
            <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/nasze_zobowiazania"
              target="_blank">Nasze
              zobowiązania</a>
            <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/formularz_kontaktowy"
              target="_blank">Kontakt</a>
          </div>
          <hr class="footer-hr" />
        </div>
      </div>

      <div class="col-lg col-md-4  justify-content-center">
        <div class="block">
          <div class="footer-group-container">
            <div class="footer-group-item-title" onclick="toggleFooter(this, 'footerKontaktDoSklepu')">
              Kontakt do sklepu
              <span class="float-end footer-group-item-caret"><i class="fa fa-angle-down"></i></span>
            </div>
            <div class="footer-group-items-container " id="footerKontaktDoSklepu">
              <p class="footer-group-item nowrap description" href="http://franczyza.bricomarche.pl/" target="_blank">Wybierz dogodną dla siebie lokalizację i <br />skontaktuj się z nami
              </p>
              <a href="https://www.bricomarche.pl/sklepy" class="clean-link" target="_blank">
                <div class="link-button">
                  Wybierz lokalizację
                </div>
              </a>
            </div>
            <hr class="footer-hr" />
          </div>
        </div>
    
        <div class="block">
          <div class="footer-group-container">
            <div class="footer-group-item-title" onclick="toggleFooter(this, 'footerStrefaBiznesu')">
              Strefa biznesu
              <span class="float-end footer-group-item-caret"><i class="fa fa-angle-down"></i></span>
            </div>
            <div class="footer-group-items-container" id="footerStrefaBiznesu">
              <a class="footer-group-item nowrap" href="http://franczyza.bricomarche.pl/" target="_blank">Franczyza</a>
              <a class="footer-group-item nowrap" href="https://www.bricomarche.pl/nieruchomosci"
                target="_blank">Nieruchomości</a>
            </div>
            <hr class="footer-hr" />
          </div>
        </div>
      </div>

    </div>
    <hr class="footer-bottom-hr" />
    <div class="row " style="margin-top:20px">
      <div class="dflex-space ">
        <div class="">
          <span class="footer-dolacz">Dołącz do nas</span>
          <a class="footer-link-icon" href="https://www.youtube.com/channel/UCdP2EzpdHc6z05kta--u-9w"
            target="_blank"><img src="./assets/images/yt.png" /></a>
          <a class="footer-link-icon" href="https://www.facebook.com/BricomarchePolska" target="_blank"><img
              src="./assets/images/fb.png" /></a>
          <a class="footer-link-icon" href="https://www.instagram.com/bricomarche_polska/" target="_blank"><img
              src="./assets/images/insta.png" /></a>
        </div>
        <div class="dflex-center col-center">
          <div class="dflex-center payments ">
            <h4>Metody płatności</h4>
            <div class="row justify-content-center">
              <div class="logo sprite-przelewy2401"></div>
              <div class="logo sprite-mastercard01"></div>
              <div class="logo sprite-visa01"></div>
              <div class="logo sprite-blik"></div>
              <div class="logo sprite-paypo_white"></div>
            </div>
          </div>

        </div>
        <div class="dflex-center ">
          <a href="http://muszkieterowie.pl/" target="_blank"><img src="./assets/images/muszkieterowie_logo.png" /></a>
        </div>
      </div>
    </div>
    <div class="row disclaimer justify-content-center">
      <p style="text-align: center;">
        Informacje handlowe o towarach i ich cenach podane na stronach serwisu: <a
          href="https://www.bricomarche.pl/">https://www.bricomarche.pl/</a> nie stanowią oferty, a są wyłącznie
        zaproszeniem do zawarcia umowy w rozumieniu art. 71 Kodeksu cywilnego.
      </p>
    </div>
  </div>
</div>